/* eslint-disable @typescript-eslint/no-explicit-any */
import { Col, Row } from "antd";
import { SelectField } from "../../../../../../atoms/FormFields";

export default function ProductionTeams(props: any) {
  const { control, fields, productionListDropdown, crewListDropdown } = props;

  return (
    <>
      {fields?.length > 0 ? (
        <>
          {fields.map((item: any, ind: number) => (
            <Row
              gutter={16}
              key={item?.id}
              style={{ display: "flex", alignItems: "center" }}
              className="assign_prod_items_row"
            >
              <Col span={8}>
                <div className="serviceLineSelected">
                  <p>
                    <span
                      style={{
                        backgroundColor: "#00A07D",
                        borderRadius: "100px",
                        height: "12px",
                        width: "12px",
                        display: "inline-block",
                        marginRight: "8px",
                      }}
                    ></span>
                    {item?.name}
                  </p>
                </div>
              </Col>
              <Col span={8} className="mb-0">
                <SelectField
                  fieldName={`production.${ind}.production_manager_id`}
                  label=""
                  control={control}
                  selectOption={productionListDropdown || []}
                  iProps={{
                    placeholder: "Select manager",
                  }}
                />
              </Col>
              <Col span={8} className="mb-0">
                <SelectField
                  fieldName={`production.${ind}.crew_id`}
                  label=""
                  control={control}
                  selectOption={crewListDropdown || []}
                  iProps={{
                    placeholder: "Select crew",
                  }}
                />
              </Col>
            </Row>
          ))}
        </>
      ) : (
        <div className="whenEmpty">
          <h3> There are no materials </h3>
          <p> Click “+” to add a material to this service. </p>
        </div>
      )}
    </>
  );
}
